import { put, call } from "redux-saga/effects";

import { speciality, specialityStatus } from "../../Services/Speciality";

export function* specialitySaga(action) {
  const { payload } = action;
  try {
    const res = yield call(speciality, payload);

    yield put({ type: "REQ_SPECIALITY_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_SPECIALITY_FAILED", errData: e });
  }
}

export function* specialityStatusSaga(action) {
  const { payload } = action;
  try {
    const res = yield call(specialityStatus, payload);

    yield put({ type: "REQ_SPECIALITY_STATUS_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_SPECIALITY_STATUS_FAILED", errData: e });
  }
}
